import PropTypes from 'prop-types';
import React from 'react';

import Ad from '../../../../models/banner/Ad';
import { modelOf } from '../../../../prop-types';
import BannerVideoType from '../../../../types/banner/BannerVideoType';

const BannerMediaVideo = ({ banner, onVideoPlaybackChange }) => {
  const emitVideoPlaybackChange = (isPlaying) => {
    onVideoPlaybackChange &&
      onVideoPlaybackChange({
        bannerId: banner.id,
        isPlaying,
      });
  };

  const renderVideoFile = () => {
    return (
      <video
        controls
        loop
        preload="none"
        poster={banner.video_poster}
        onPlay={() => emitVideoPlaybackChange(true)}
        onPause={() => emitVideoPlaybackChange(false)}
        onEnded={() => emitVideoPlaybackChange(false)}
      >
        <source src={banner.video_file} type={banner.video_mime_type} />
      </video>
    );
  };

  const renderEmbedMedia = () => {
    return (
      <iframe
        src={banner.video_link}
        loading="lazy"
        frameBorder="0"
        title={banner.seo_description || banner.title || 'Banner video'}
      />
    );
  };

  return (
    <div className="Banner__video-container Banner__media">
      {banner.video_embed_style === BannerVideoType.FILE
        ? renderVideoFile()
        : renderEmbedMedia()}
    </div>
  );
};

BannerMediaVideo.propTypes = {
  banner: modelOf(Ad).isRequired,
  onVideoPlaybackChange: PropTypes.func,
};

export default BannerMediaVideo;
